import { ButtonBase, Typography, Stack, styled } from "@mui/material";
import React from "react";

const UseCaseCard = ({ label, description, selected, onClick, testId }) => (
  <StyledCard
    data-testid={testId}
    selected={selected}
    onClick={onClick}
  >
    <Stack gap={0.5} alignItems="flex-start">
      <Typography variant="subtitle2" fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="caption" color="text.600">
        {description}
      </Typography>
    </Stack>
  </StyledCard>
);

const StyledCard = styled(ButtonBase)(({ theme, selected }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  width: "100%",
  display: "flex",
  alignItems: "flex-start",
  textAlign: "left",
  flexDirection: "column",
  justifyContent: "flex-start",
  transition: "border-color 0.2s",
  ...(selected && {
    outline: `2px solid ${theme.palette.secondary[500]}`,
    outlineOffset: -2,
    borderColor: "transparent"
  }),
  "&:hover": {
    backgroundColor: theme.palette.tertiary[100],
    borderColor: selected ? "transparent" : theme.palette.grey[400]
  }
}));

export default UseCaseCard;
